




























































import Vue from 'vue'
import VueRecaptcha from 'vue-recaptcha'
import PasswordVerificationRules from '@/components/PasswordVerificationRules.vue'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
import { unmask } from '@/utility/helpers'
import { mapGetters } from 'vuex'
import User from '@/types/User.interface'
export default Vue.extend({
    components: { PasswordVerificationRules, VueRecaptcha },
    mixins: [tenantNavMixin],
    props: {
        //  Our user who was invited
        invitedUser: {
            type: Object,
            required: true
        },
        //  Condition if user exists (still need to add to tenant)
        userExists: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            loading: false,
            //  V-model for user's mobilephone, used for validation purposes
            mobilephone: null,
            // The recaptcha key
            recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
            //  show password
            showPassword: false,
            // The submission state, used for recaptcha
            submitting: false
        }
    },
    computed: {
        ...mapGetters([
            'isApp',
            'recaptchaVerifiedTime',
            'recaptchaVerified',
            'showRecaptcha'
        ]),
        linkTarget(): string {
            //  If we are on app, use system, else use blank
            return this.isApp ? '_system' : '_blank'
        },
        termsLink(): string {
            return `${process.env.VUE_APP_URL_SITE}/terms`
        },
        token(): string {
            return this.$route.query.token || null
        },
        user(): User {
            return this.$store.getters.user
        }
    },
    methods: {
        hasErrors(name: string) {
            //  Check for existing validation errors
            const hasErrors = this.errors.collect(name).length > 0

            //  If the field has errors, return true
            if (hasErrors) return true
        },
        mobilephoneSet(value: string): void {
            //  Unmask the value
            let phone = unmask(value, '(###) ###-####')

            //  Add the north american country code
            phone = `1${phone}`

            //  Set the user's mobilephone
            this.invitedUser.mobilephone = phone
        },
        async onCaptchaVerified(token: string): Promise<void> {
            // Set the submission flag to true to disable the submit button
            this.submitting = true

            // Reset the reCAPTCHA widget
            this.$refs.recaptcha.reset()

            // Verify the reCAPTCHA token
            const success = await this.$store.dispatch('verifyRecaptcha', token)

            // If NOT successful (reCAPTCHA thinks user is a bot), pop the challenge
            if (!success) this.$refs.recaptcha.execute()

            // Set the submission flag to true to enable the submit button
            this.submitting = false

            // If successful (reCAPTCHA thinks user is human), submit
            this.submit()
        },
        onCaptchaExpired(): void {
            // Reset the reCAPTCHA widget
            this.$refs.recaptcha.reset()
        },
        popRecaptcha() {
            //  If 'recaptcha' is disabled, do nothing
            if (!this.showRecaptcha) return

            //  Else, check if the user is already verified
            const isVerified =
                this.recaptchaVerified &&
                Number(new Date()) - this.recaptchaVerifiedTime > 120000

            //  If the user is already verified, we skip recaptcha
            if (isVerified) return

            //  Else, pop recaptcha challenge
            this.$refs.recaptcha.execute()
        },
        async submit(): Promise<void> {
            //  Validate the form
            const valid = await this.$validator.validateAll()

            //  If the form is NOT valid AND user does NOT exist, do nothing
            if (!valid && !this.userExists) return

            //  Split the full name into first and last
            const names = this.invitedUser.fullname.split(' ')

            //  Clone the user, this way we don't end up modifying the actual user
            const payload = window._.cloneDeep(this.invitedUser)

            //  First name is the first index
            payload.firstname = names.splice(0, 1)[0]

            //  Last name is every other index combined
            payload.lastname = names.join(' ')

            // Get the user-inputted phone number
            const phone = payload.mobilephone

            // Unmask the phone number
            const unmasked = phone.replace(/\D/g, '')

            //  If our phone unmasked is 10 characters, update it
            if (unmasked.length == 10) {
                // Update user with the correct number (1 appended for country code)
                payload.mobilephone = `1${unmasked}`
            }

            //  If the user already exists, attach id
            if (this.user) payload.id = this.user.id

            //  For tenant connection purposes, we have to add our tenant subdomain to this payload
            payload.tenant_subdomain = this.$route.query.tenant

            //  Attach the token in order to find the invitation
            payload.token = this.$route.query.token

            //  Pop recaptcha
            this.popRecaptcha()

            //  Start the loading spinner
            this.loading = true

            //  Send the user post request
            const response = await this.$store.dispatch('invitationUserPost', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            await this.$store.dispatch('authUserGet', {'userToken': response.userToken, 'twoFactorToken': response.twoFactorToken})

            //  Emit to the parent
            this.$emit('submit')
        }
    }
})
